<template>
  <div>
    <b-card
      class="gradient-card"
      style="width: 100%; height: 650px; border-radius: 10px;"
    >
      <b-row>
        <b-col
          cols="12"
          class="mb-1"
        >
          <span style="font-size:20px; color: #fff;">ตารางรายละเอียดการบุกรุก</span>
        </b-col>
        <b-col
          lg="4"
          md="4"
          class="d-flex align-items-center justify-content-start mb-1"
        >
          <label>ค้นหา</label>
          <b-input-group
            size="sm"
            style="padding-left:14px;"
          >
            <b-form-input
              id="filterInput"
              v-model="filter"
              type="search"
              placeholder="ป้อนคำค้นหา"
              label-cols-sm="12"
              label-cols-md="2"
              label-cols-lg="2"
              style=" background-color:rgba(0,0,0, 0.6);"
            />
            <b-input-group-append>
              <b-button
                :disabled="!filter"
                @click="filter = ''"
              >
                ล้าง
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col cols="12">
          <b-table
            responsive
            :per-page="perPage"
            :current-page="currentPage"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template #cell(FilePath)="data">
              <b-img
                :src="data.item.FilePath"
                width="150px"
                fluid
                @click="showImg(data.item.FilePath)"
              />
            </template>
          </b-table>
        </b-col>
        <b-col
          cols="12"
        >
          <b-card-body class="d-flex justify-content-between flex-wrap pt-1">
            <!-- page length -->
            <b-form-group
              label="Per Page"
              label-cols="6"
              label-align="left"
              label-size="sm"
              label-for="sortBySelect"
              class="text-nowrap mb-md-0 mr-1"
            >
              <b-form-select
                id="perPageSelect"
                v-model="perPage"
                size="sm"
                inline
                :options="pageOptions"
              />
            </b-form-group>

            <!-- pagination -->
            <div>
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                first-number
                last-number
                prev-class="prev-item"
                next-class="next-item"
                class="mb-0"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </div>
          </b-card-body>
        </b-col>
      </b-row>
      <modal-Project ref="pid2" />
    </b-card>
  </div>
</template>

<script>
import {
  BRow, BCol, BTable, BButton, BCard, BPagination, BInputGroup, BInputGroupAppend, BFormInput, BImg,
} from 'bootstrap-vue'
import axios from '@axios'
import modalProject from '@/views/modal/modalProject.vue'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    modalProject,
    BButton,
    BCard,
    BPagination,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BImg,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      fields: [
        {
          key: 'DATE_TIME',
          label: 'วันที่',
          sortable: false,
          class: 'text-center',
        },
        {
          key: 'EventType',
          label: 'เหตุการณ์',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'CAMID',
          label: 'กล้องที่',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'FilePath',
          label: 'ภาพเหตุการณ์',
          class: 'text-center',
        },
      ],
      Total: '',
      Online: '',
      Offline: '',
      items: [],
      perPage: 3,
      pageOptions: [25, 50, 75, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      status: [{
        Online: 'ออนไลน์', Offline: 'ออฟไลน์',
      },
      {
        Online: 'success', Offline: 'danger',
      }],
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // ทำ action ที่คุณต้องการเมื่อ path เปลี่ยน (แม้เป็น path เดิม)
      this.getIntruderTable()
    },
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getIntruderTable()
    this.getSumSpeaker()
  },
  methods: {
    getIntruderTable() {
      axios
        .post('/tableIntruderDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length
        })
        .catch(error => {
          console.log(error)
        })
    },
    showImg(img) {
      this.$swal({
        imageUrl: img,
        imageAlt: 'Custom image',
        width: 800,
        background: 'hsla(0, 100%, 100%, 0)',
        showCancelButton: false,
        showConfirmButton: false,
        showCloseButton: true,
      })
    },
    getSumSpeaker() {
      axios
        .post('/totalSpeaker-Tunnel', { wid: this.$route.query.wid })
        .then(response => {
          this.Total = response.data[0].Total
          this.Online = response.data[0].Online
          this.Offline = response.data[0].Offline
        })
        .catch(error => {
          console.log(error)
        })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>

<style lang="scss" scoped>
  .vue2leaflet-map {
    &.leaflet-container{
      position: absolute;
      width: 1454px;
      height: 568px;
    }
  }
  .gradient-card {
  background:
    linear-gradient(to right, rgba(22, 60, 73, 1) 0%, rgba(22, 52, 73, 0.5) 25%, rgba(0,0,0,0) 50%, rgba(0, 111, 30, 0.0) 75%, rgba(0,0,0,0) 100%),
    linear-gradient(to left, rgba(22, 60, 73, 1) 0%, rgba(22, 52, 73, 0.5) 25%, rgba(0,0,0,0) 50%, rgba(0, 111, 30, 0.0) 75%, rgba(0,0,0,0) 100%),
    linear-gradient(to bottom, rgba(22, 60, 73, 0.5) 0%, rgba(22, 52, 73, 0.1) 20%, rgba(0,0,0,0) 50%, rgba(0, 111, 30, 0.0) 75%, rgba(0,0,0,0) 100%),
    linear-gradient(to top, rgba(22, 60, 73, 0.5) 0%, rgba(22, 52, 73, 0.1) 20%, rgba(0,0,0,0) 50%, rgba(0, 111, 30, 0.0) 75%, rgba(0,0,0,0) 100%);
  background-size: 100% 100%, 100% 100%, 100% 100%, 100% 100%;
  background-position: 0 0, 0 100%, 0 0, 100% 0;
  background-repeat: no-repeat;
  border: 1px solid rgb(30, 83, 100, 0.7);
}
</style>
